import './WatchGuideLink.css';
import { useNavigate } from 'react-router-dom';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

/**
 * Small inline link that opens the Video Guides page directly to a specific
 * video. Drop it on any page that needs a "Watch Guide" shortcut.
 *
 * @param {string} videoId - id of the target video in videoGuidesData.js
 *                           (e.g. 'creating-a-vertical')
 * @param {string} label   - text shown after the icon
 *                           (e.g. 'Watch Guide: Creating a Vertical')
 */
const WatchGuideLink = ({ videoId, label }) => {
  const navigate = useNavigate();

  return (
    <span
      className="watch-guide-link"
      role="link"
      tabIndex={0}
      onClick={() => navigate(`/video-guides?video=${videoId}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          navigate(`/video-guides?video=${videoId}`);
        }
      }}
    >
      <HelpOutlineOutlinedIcon sx={{ fontSize: 16 }} />
      {label && <span className="watch-guide-link-text">{label}</span>}
    </span>
  );
};

export default WatchGuideLink;
